define("settings/components/navigation-sidebar", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "later/utils/get-page-from-window", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _getPageFromWindow, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"later/utils/get-page-from-window",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <section class="o--page__sidebar o--page__sidebar--full">
    <NavigationHeader @slug={{this.lastGroup.slug}} />
    <NavigationList>
      <NavigationListItem
        @linkTo="overview"
        @qaClass="qa--sidebar__link--accountSettings"
        @title={{t "account.navigation.account_settings"}}
        data-test-id="account-settings"
      />
      <NavigationListItem
        @linkTo="groups"
        @qaClass="qa--sidebar__link--socialSetsAndAccessGroups"
        @title={{html-safe (t "account.navigation.social_sets_groups")}}
        class="at--autoPublish__socialSetsGroups at--autoPublishEnable__socialSetsGroups"
        data-test-id="access-groups"
      />
      <NavigationListItem
        @linkTo="users"
        @qaClass="qa--sidebar__link--users"
        @title={{t "shared_words.users"}}
        data-test-id="users"
      />
      <NavigationListItem
        @linkTo="subscription"
        @qaClass="qa--sidebar__link--subscription"
        @title={{t "account.navigation.subscription"}}
        data-test-id="subscription"
        {{on "mouseenter" (action "loadPayments")}}
      />
      <NavigationListItem
        @linkTo="devices"
        @qaClass="qa--sidebar__link--devicesAndNotifications"
        @title={{t "account.navigation.notifications_devices"}}
        data-test-id="notifications-devices"
      />
      <li class="tAC--sidebar__item u--m__t__lg" data-test-id="logout">
        <Shared::Ui::Button
          @additional="block"
          @onClick={{this.logout}}
          @text={{t "header.logout"}}
          @variant="unstyled"
          class="tAC--sidebar__link qa--sidebar__link--logout"
        />
      </li>
    </NavigationList>
  
    {{#if this.lastGroup}}
      <Shared::ReferralPromoBanner />
      <NavigationFooter @logout={{this.logout}} @openChatbot={{this.openChatbot}} @slug={{this.lastGroup.slug}} />
    {{/if}}
  </section>
  */
  {
    "id": "Q10qnKED",
    "block": "[[[10,\"section\"],[14,0,\"o--page__sidebar o--page__sidebar--full\"],[12],[1,\"\\n  \"],[8,[39,0],null,[[\"@slug\"],[[30,0,[\"lastGroup\",\"slug\"]]]],null],[1,\"\\n  \"],[8,[39,1],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"account-settings\"]],[[\"@linkTo\",\"@qaClass\",\"@title\"],[\"overview\",\"qa--sidebar__link--accountSettings\",[28,[37,3],[\"account.navigation.account_settings\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,0,\"at--autoPublish__socialSetsGroups at--autoPublishEnable__socialSetsGroups\"],[24,\"data-test-id\",\"access-groups\"]],[[\"@linkTo\",\"@qaClass\",\"@title\"],[\"groups\",\"qa--sidebar__link--socialSetsAndAccessGroups\",[28,[37,4],[[28,[37,3],[\"account.navigation.social_sets_groups\"],null]],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"users\"]],[[\"@linkTo\",\"@qaClass\",\"@title\"],[\"users\",\"qa--sidebar__link--users\",[28,[37,3],[\"shared_words.users\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"subscription\"],[4,[38,5],[\"mouseenter\",[28,[37,6],[[30,0],\"loadPayments\"],null]],null]],[[\"@linkTo\",\"@qaClass\",\"@title\"],[\"subscription\",\"qa--sidebar__link--subscription\",[28,[37,3],[\"account.navigation.subscription\"],null]]],null],[1,\"\\n    \"],[8,[39,2],[[24,\"data-test-id\",\"notifications-devices\"]],[[\"@linkTo\",\"@qaClass\",\"@title\"],[\"devices\",\"qa--sidebar__link--devicesAndNotifications\",[28,[37,3],[\"account.navigation.notifications_devices\"],null]]],null],[1,\"\\n    \"],[10,\"li\"],[14,0,\"tAC--sidebar__item u--m__t__lg\"],[14,\"data-test-id\",\"logout\"],[12],[1,\"\\n      \"],[8,[39,7],[[24,0,\"tAC--sidebar__link qa--sidebar__link--logout\"]],[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,0,[\"logout\"]],[28,[37,3],[\"header.logout\"],null],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"lastGroup\"]],[[[1,\"    \"],[8,[39,9],null,null,null],[1,\"\\n    \"],[8,[39,10],null,[[\"@logout\",\"@openChatbot\",\"@slug\"],[[30,0,[\"logout\"]],[30,0,[\"openChatbot\"]],[30,0,[\"lastGroup\",\"slug\"]]]],null],[1,\"\\n\"]],[]],null],[13]],[],false,[\"navigation-header\",\"navigation-list\",\"navigation-list-item\",\"t\",\"html-safe\",\"on\",\"action\",\"shared/ui/button\",\"if\",\"shared/referral-promo-banner\",\"navigation-footer\"]]",
    "moduleName": "settings/components/navigation-sidebar.hbs",
    "isStrictMode": false
  });
  let NavigationSidebarComponent = _exports.default = (_dec = (0, _service.inject)('chatbot/chatbot-wrapper'), (_class = class NavigationSidebarComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "payment", _descriptor2, this);
      _initializerDefineProperty(this, "integrationsQueue", _descriptor3, this);
      _initializerDefineProperty(this, "chatbotWrapper", _descriptor4, this);
    }
    get lastGroup() {
      return this.auth.lastGroup;
    }
    loadPayments() {
      this.payment.retrieve.perform();
    }
    logout() {
      this.auth.logout.perform();
    }
    openChatbot(location) {
      this.integrationsQueue.addToQueue(this.chatbotWrapper.name, true);
      this.chatbotWrapper.open(location, (0, _getPageFromWindow.default)());
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "integrationsQueue", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "chatbotWrapper", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "loadPayments", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "loadPayments"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "logout", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "logout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openChatbot", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "openChatbot"), _class.prototype)), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationSidebarComponent);
});